/**
 * E2E test detection for analytics.
 * Used so we don't init or send events in Playwright/test browsers.
 */

export function isE2ETestEnvironment(): boolean {
  if (typeof window === 'undefined') return false;
  return !!(
    (window as any).__E2E_TEST__ ||
    (window as any).__PLAYWRIGHT_TEST__ ||
    (window as any).Playwright
  );
}
